(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/searchresults/receiver-search-empty.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/searchresults/receiver-search-empty.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.ReceiverSearchEmpty = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.receiver_search_empty(data);
    },

    templateContext: function() {
      var data = {};
      data = data || {};
      data.searchQuery =
        this.getOption('searchQuery') ||
        decodeURIComponent(svs.grassroots.data.searchQuery || '');
      return data;
    },

    tagName: 'div',
    className: 'search-result-receiver'
  });
})(Backbone, _, svs);


 })(window);